import { useDispatch } from 'react-redux';
import React, { useLayoutEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { initializePageAction } from '../../store/theme.actions';
import withTokenInterceptor from '../../hoc/withTokenInterceptor/withTokenInterceptor';
import InformacoesLancamento from './InformacoesLancamento';

function NovoLancamentoPage() {
  const dispatch = useDispatch();
  const history = useHistory();

  dispatch(initializePageAction('Caixa de Filiais >  Novo Lançamento'));

  const [idFilial, setIdFilial] = useState(null);

  useLayoutEffect(() => {
    if (history.location.state?.idFilial && !history.location.state?.idCaixaFilial) {
      setIdFilial(history.location.state?.idFilial);
    } else {
      history.goBack();
    }
  }, [history]);

  return (
    <>
      <InformacoesLancamento isInsertMode idFilial={idFilial} />
    </>
  );
}

export default withTokenInterceptor(NovoLancamentoPage);
